import { CommonMapLayers } from '@components/map/layers/CommonMapLayers';
import FlightPlanLayer from '@components/map/layers/flightPlans/operational/FlightPlanLayer';
import { PlatformLayer } from '@components/map/layers/platforms/PlatformLayer';
import SelectionLayer from '@components/map/layers/SelectionLayer';
import ZoneLayer from '@components/map/layers/zones/ZoneLayer';

import MapboxMap from './MapboxMap';

export function ReplayMap() {
  // Do not add controls here
  return (
    <MapboxMap>
      <PlatformLayer />
      <ZoneLayer />
      <FlightPlanLayer />
      <CommonMapLayers />
      <SelectionLayer />
    </MapboxMap>
  );
}
